__turbopack_context__.v({
  "aspect-1-1": "EditorialContentCard-module-scss-module__t6bfYa__aspect-1-1",
  "aspect-16-9": "EditorialContentCard-module-scss-module__t6bfYa__aspect-16-9",
  "aspect-3-2": "EditorialContentCard-module-scss-module__t6bfYa__aspect-3-2",
  "aspect-4-3": "EditorialContentCard-module-scss-module__t6bfYa__aspect-4-3",
  "aspectSquare": "EditorialContentCard-module-scss-module__t6bfYa__aspectSquare",
  "author": "EditorialContentCard-module-scss-module__t6bfYa__author",
  "authorImage": "EditorialContentCard-module-scss-module__t6bfYa__authorImage",
  "authorName": "EditorialContentCard-module-scss-module__t6bfYa__authorName",
  "authorPosition": "EditorialContentCard-module-scss-module__t6bfYa__authorPosition",
  "card": "EditorialContentCard-module-scss-module__t6bfYa__card",
  "card--featured": "EditorialContentCard-module-scss-module__t6bfYa__card--featured",
  "card--grid": "EditorialContentCard-module-scss-module__t6bfYa__card--grid",
  "card--inlineContent": "EditorialContentCard-module-scss-module__t6bfYa__card--inlineContent",
  "card--list": "EditorialContentCard-module-scss-module__t6bfYa__card--list",
  "card--opinion": "EditorialContentCard-module-scss-module__t6bfYa__card--opinion",
  "content": "EditorialContentCard-module-scss-module__t6bfYa__content",
  "headline": "EditorialContentCard-module-scss-module__t6bfYa__headline",
  "horizontal": "EditorialContentCard-module-scss-module__t6bfYa__horizontal",
  "image": "EditorialContentCard-module-scss-module__t6bfYa__image",
  "lead": "EditorialContentCard-module-scss-module__t6bfYa__lead",
  "link": "EditorialContentCard-module-scss-module__t6bfYa__link",
  "mediaContainer": "EditorialContentCard-module-scss-module__t6bfYa__mediaContainer",
  "reverse": "EditorialContentCard-module-scss-module__t6bfYa__reverse",
  "tag": "EditorialContentCard-module-scss-module__t6bfYa__tag",
  "vertical": "EditorialContentCard-module-scss-module__t6bfYa__vertical",
});
